import { useRoute, useRouteParams } from '#imports'
import { computed } from 'vue'
import type { LocationQueryValue } from 'vue-router'

import type { Grade } from '@backmarket/http-api'

import { useMasterPPScale } from './useMasterPPScale/useMasterPPScale'

export type UrlParams = Readonly<{
  productId: string
  slug: string
  grade?: Grade['value']
  offerType?: 7
  mobilePlan?: string
}>

const fromQueryParam = (
  param: LocationQueryValue | LocationQueryValue[],
): string | null => (Array.isArray(param) ? param[0] : (param ?? null))

const fromQueryParamAsNumber = (
  param: LocationQueryValue | LocationQueryValue[],
): number | null => {
  const p = fromQueryParam(param)

  return p ? parseInt(p, 10) : null
}

export const useUrlParams = () => {
  const { uuid, slugV2: slug } = useRouteParams()
  const route = useRoute()
  const {
    isMasterPPScaleUrl,
    masterPPScaleProductId,
    masterPPScaleGrade,
    masterPPScaleSpecialOfferType,
  } = useMasterPPScale()

  const grade = computed(() =>
    isMasterPPScaleUrl.value
      ? masterPPScaleGrade.value
      : fromQueryParamAsNumber(route.query?.l),
  )
  const offer = computed(() =>
    isMasterPPScaleUrl.value
      ? masterPPScaleSpecialOfferType.value
      : fromQueryParamAsNumber(route.query?.offerType),
  )
  const mobilePlan = computed(() =>
    fromQueryParam(route.query?.mobilePlanOfferId),
  )

  const productId = isMasterPPScaleUrl.value
    ? masterPPScaleProductId.value
    : uuid

  return {
    productId,
    slug,
    grade,
    offerType: offer,
    mobilePlan,
  }
}
